import { Box } from '@mui/material'
import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { useRegister } from '@refinedev/core'
import { useForm } from 'react-hook-form'
import { RegisterHeader, RegisterForm } from './components'

type TRegisterFormData = {
  password: string
  confirmPassword: string
}

export const Register = () => {
  const [searchParams] = useSearchParams()
  const [passwordValidation, setPasswordValidation] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    digit: false,
  })

  const { mutate: register, isLoading } = useRegister()

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors, isValid },
  } = useForm<TRegisterFormData>({
    mode: 'onChange',
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
  })

  const watchedPassword = watch('password')

  useEffect(() => {
    const validation = {
      length: watchedPassword.length >= 8,
      uppercase: /[A-Z]/.test(watchedPassword),
      lowercase: /[a-z]/.test(watchedPassword),
      digit: /\d/.test(watchedPassword),
    }
    setPasswordValidation(validation)
  }, [watchedPassword])

  const token = searchParams.get('token')

  const onSubmit = (data: TRegisterFormData) => {
    register({ password: data.password, token })
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.paper', position: 'relative' }}>
      <RegisterHeader />
      <RegisterForm
        control={control}
        errors={errors}
        isValid={isValid}
        isLoading={isLoading}
        passwordValidation={passwordValidation}
        watchedPassword={watchedPassword}
        onSubmit={handleSubmit(onSubmit)}
      />
    </Box>
  )
}
